<template>
  <div class="newsPage">
    <!-- <Header activeIndex="/news" /> -->
    <div>
      <img
        style="width: 100%;margin-top:82px"
        src="@/assets/other/news.jpg"
        alt=""
      />
    </div>
    <Nav title="新闻中心" />
    <div class="pagew mid">
      <h2 class="list_card">
        <i class="el-icon-chat-line-square"></i>最新活动
      </h2>
      <div class="list"  >
        <div class="list-box" v-for="item in listdata" :key="item.id" @click="toPage(item)">
          <div class="left-box">
            <div class="day">{{ item.day }}</div>
            <div class="year">{{ `${item.year} - ${item.month}` }}</div>
          </div>
          <div class="right-box">
            <div class="title">{{ item.title }}</div>
            <div class="text-overflow content">{{ item.introduce }}</div>
          </div>
        </div>
        <div style="margin-top: 30px">
          <el-pagination
            layout="prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Nav from "../../components/Nav/Nav.vue";
// 发送请求
import { getNewsList } from "@/api/api.js";
import { lbdata } from "./data";

export default {
  components: { Nav },
  data() {
    return {
      hotList: [],
      listdata: [], // 返回的数据
      count: 5000,
      total: 0,
      currentPage: 1
    };
  },
  // 初始化方法
  created() {
    // this.getHotList();
    this.getList();
  },
  // 要加载的方法
  methods: {
    handleCurrentChange(val) {
      // 获取当前页数
      this.currentPage = val;
      // 调用新闻列表方法
      this.getList();
    },
    getHotList() {
      getNewsList({ pageNum: 1, type: "5", pageSize: 4 }).then(res => {
        const { total, rows = [] } = res.data;
        this.hotList = rows;
      });
    },
    //  请求新闻列表
    getList() {
      getNewsList({ pageNum: this.currentPage, type: "2", pageSize: 10 }).then(
        res => {
          const { total, rows = [] } = res.data;
          this.total = total;
          rows.forEach(item => {
            if (item.time && item.time !== "") {
              let i = item.time.split("-");
              item.day = i[2];
              item.month = i[1];
              item.year = i[0];
            }
          });
          console.log(rows);
          this.listdata = rows;
        }
      );
    },
    go(code) {
      this.index = code;
    },
    toPage(item) {
      // const { id, title } = item;
      this.$router.push({
        path: "/news/newsdetail",
        query: {
          id: item.id,
          title: item.title
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.list ::v-deep .el-pagination .el-pager li .active {
  background-color: #25877d !important;
}

.newsPage {
  .mid {
    padding: 40px 0;
  }

  .lb-text {
    width: 600px;
    color: black;
    text-align: start;
    position: relative;

    .date {
      color: rgb(37, 135, 125);
      font-size: 18px;
      margin-bottom: 10px;
    }

    .title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .content {
      line-height: 20px;
      margin-bottom: 20px;
      height: 80px;
      -webkit-line-clamp: 4;
      text-align: justify;
    }

    .eye {
      width: 100%;
      position: absolute;
      bottom: 0;
      background: #f8f5f0;
      padding: 10px 0;
      text-align: center;

      img {
        width: 37px;
      }
    }
  }

  .list-box {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    // border-top: 1px solid lightgray;
    border-bottom: 1px solid #ececec;
    padding: 30px 0;
    margin-top: 20px;
    text-align: start;

    .left-box {
      width: 90px;
      padding-left: 20px;
      padding-top: 12px;
      height: 90px;
      background-color: rgb(248, 245, 240);

      .day {
        font-size: 35px;
        color: rgb(37, 135, 125);
      }

      .month,
      .year {
        color: rgb(139, 138, 136);
      }
    }

    .right-box {
      text-align: start;
      width: 88%;
      padding-top: 20px;

      .title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 25px;
      }
    }
  }

  .list .list-box:first-child {
    border-top: 1px solid lightgray;
  }

  .el-carousel__item h3 {
    color: rgb(37, 135, 125);
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item .is-active {
    :deep(.is-active) {
      background-color: #25877d;
    }
  }

  .el-carousel__item:nth-child(2n) {
    // background-color: gray;
  }

  .el-carousel__item:nth-child(2n + 1) {
    // background-color: gray;
  }
}
.list_card {
  text-align: left !important;
}
.box-card-li {
  margin-left: 25px;
}
</style>
<style lang="scss">
.newsPage {
  .el-carousel__button {
    background: #c1c1c1;
  }

  .is-active .el-carousel__button {
    background: #25877d;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/news/news.vue